import { BitkitRibbon } from '@bitrise/bitkit-v2';
import { useContext, useState } from 'react';

import { GlobalPropsContext } from '@/components/page/GlobalPropsContext';
import { useMutateUserMetadata } from '@/hooks/api/useUserMetadata';
import { exceededLimitsPath } from '@/utils/monolithApiRouteService';

const PlanDowngradeBanner = () => {
  const { account } = useContext(GlobalPropsContext);

  const isOwner = account?.isOwner;

  const { mutate } = useMutateUserMetadata({ transform: false });

  const [isClosed, setIsClosed] = useState(false);

  if (!account || isClosed) {
    return null;
  }

  const onRibbonClose = () => {
    mutate({ [`scheduled_downgrade_banner_notification_on_${account.slug}`]: false });
    setIsClosed(true);
  };

  const action = isOwner ? { href: exceededLimitsPath(account.slug), label: 'Manage exceeded limits' } : undefined;

  return (
    <BitkitRibbon
      colorVariant="yellow"
      onDismiss={onRibbonClose}
      action={action}
      title="Your plan change will be effective in 5 days."
    >
      By switching to the new plan, you will exceed some of its limits.
    </BitkitRibbon>
  );
};

export default PlanDowngradeBanner;
